// import { motion } from 'framer-motion'
// import { Clock, Award, Lock, CheckCircle, BookOpen, Users, Star } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'
// import useStore from '../store/useStore'
// import { useState } from 'react'

// function CourseCard({ course }) {
//   const navigate = useNavigate()
//   const { enrolledCourses, accessTier } = useStore()
//   const [isHovered, setIsHovered] = useState(false)
//   const isEnrolled = enrolledCourses.includes(course.id)

//   const skillColors = {
//     Beginner: 'bg-green-100 text-green-700',
//     Intermediate: 'bg-yellow-100 text-yellow-700',
//     Advanced: 'bg-red-100 text-red-700'
//   }

//   const tierColors = {
//     'free': 'bg-green-100 text-green-800',
//     'premium': 'bg-blue-100 text-blue-800',
//     'scholarship': 'bg-purple-100 text-purple-800'
//   }

//   const canAccess = () => {
//     if (course.tier === 'free') return true
//     if (course.tier === 'premium' && (accessTier === 'plus' || accessTier === 'pro' || accessTier === 'business' || accessTier === 'premium_access')) return true
//     if (course.tier === 'scholarship' && (accessTier === 'pro' || accessTier === 'business' || accessTier === 'premium_access')) return true
//     return false
//   }

//   const isLocked = !canAccess()

//   const getButtonText = () => {
//     if (isLocked) {
//       if (course.tier === 'premium') return 'Plus Required'
//       if (course.tier === 'scholarship') return 'Pro Required'
//       return 'Upgrade to Access'
//     }
//     return isEnrolled ? 'Continue Learning' : 'View Course'
//   }

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       whileHover={{ y: -4 }}
//       onHoverStart={() => setIsHovered(true)}
//       onHoverEnd={() => setIsHovered(false)}
//       className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col min-h-[480px] group"
//     >
//       {/* Course Image - EXACT SAME as PodcastCard */}
//       <div className="relative h-48 bg-gray-200 flex-shrink-0">
//         <img 
//           src={course.image} 
//           alt={course.title}
//           className="w-full h-full object-cover"
//         />
        
//         {/* Badges Container - EXACT SAME as PodcastCard */}
//         <div className="absolute top-4 left-4 right-4 flex justify-between items-start">
//           {/* Left side - Skill Level */}
//           <span className={`px-3 py-1 rounded-full text-xs font-medium ${skillColors[course.skillLevel]} flex-shrink-0`}>
//             {course.skillLevel}
//           </span>
          
//           {/* Right side - Tier */}
//           <span className={`px-3 py-1 rounded-full text-xs font-medium ${tierColors[course.tier]} flex-shrink-0`}>
//             {course.tier === 'free' ? 'Free' : course.tier === 'premium' ? 'Plus' : 'Pro'}
//           </span>
//         </div>
//       </div>

//       {/* Content Area - EXACT SAME as PodcastCard */}
//       <div className="p-6 flex flex-col flex-1">
//         {/* Topic badge - Centered - EXACT SAME as PodcastCard */}
//         <div className="mb-4 flex-shrink-0 flex justify-center">
//           <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
//             {course.category}
//           </span>
//         </div>

//         {/* Title - EXACT SAME as PodcastCard */}
//         <div className="mb-3 flex-shrink-0">
//           <h3 className="text-xl font-bold text-gray-900 leading-tight text-center">
//             {course.title}
//           </h3>
//         </div>

//         {/* Description - EXACT SAME as PodcastCard */}
//         <div className="flex-1 mb-6 min-h-0">
//           <div className="text-gray-600 text-sm leading-relaxed text-center">
//             {course.description}
//           </div>
//         </div>

//         {/* Metadata - EXACT SAME as PodcastCard */}
//         <div className="flex items-center justify-between text-xs text-gray-500 mb-6 flex-shrink-0 space-x-2">
//           {/* Duration */}
//           <div className="flex items-center space-x-1.5 min-w-0 flex-1 justify-center">
//             <Clock className="w-3.5 h-3.5 flex-shrink-0" />
//             <span className="truncate">{course.duration}</span>
//           </div>
          
//           {/* Modules */}
//           <div className="flex items-center space-x-1.5 min-w-0 flex-1 justify-center">
//             <BookOpen className="w-3.5 h-3.5 flex-shrink-0" />
//             <span className="truncate">{course.modules.length} modules</span>
//           </div>
          
//           {/* Students */}
//           <div className="flex items-center space-x-1.5 min-w-0 flex-1 justify-center">
//             <Users className="w-3.5 h-3.5 flex-shrink-0" />
//             <span className="truncate">{course.students?.toLocaleString() || '0'}</span>
//           </div>
//         </div>

//         {/* Rating - EXACT SAME as PodcastCard */}
//         <div className="flex items-center justify-center text-xs text-gray-500 mb-6 flex-shrink-0">
//           <div className="flex items-center space-x-1.5">
//             <Star className="w-3.5 h-3.5 fill-current text-yellow-400 flex-shrink-0" />
//             <span>{course.rating} rating</span>
//           </div>
//         </div>

//         {/* Action Buttons - EXACT SAME as PodcastCard */}
//         <div className="flex space-x-3 mt-auto pt-4 flex-shrink-0">
//           <button
//             onClick={() => navigate(`/course/${course.id}`)}
//             disabled={isLocked}
//             className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 text-white rounded-lg font-medium transition-colors duration-200 ${
//               isLocked ? 'bg-gray-500 hover:bg-gray-600' : 'bg-primary hover:bg-primary/90'
//             }`}
//           >
//             {isLocked ? <Lock className="w-5 h-5" /> : <BookOpen className="w-5 h-5" />}
//             <span>{getButtonText()}</span>
//           </button>
          
//           {/* Certificate Button - EXACT SAME as PodcastCard's course button */}
//           {course.hasCertificate && !isLocked && (
//             <button
//               onClick={() => navigate(`/course/${course.id}#certificate`)}
//               className="flex items-center justify-center px-4 py-3 bg-yellow-500 text-white rounded-lg font-medium hover:bg-yellow-600 transition-colors duration-200 flex-shrink-0"
//               title="View Certificate Info"
//             >
//               <Award className="w-5 h-5" />
//             </button>
//           )}
//         </div>
//       </div>
//     </motion.div>
//   )
// }

// export default CourseCard
import { motion } from 'framer-motion'
import { Clock, Award, Lock, CheckCircle, BookOpen, Users, Star, AlertCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import useStore from '../store/useStore'
import { useState } from 'react'

function CourseCard({ course }) {
  const navigate = useNavigate()
  const { enrolledCourses, accessTier } = useStore()
  const [isHovered, setIsHovered] = useState(false)
  const isEnrolled = enrolledCourses.includes(course.id)

  const skillColors = {
    Beginner: 'bg-green-100 text-green-700',
    Intermediate: 'bg-yellow-100 text-yellow-700',
    Advanced: 'bg-red-100 text-red-700'
  }

  const tierColors = {
    'free': 'bg-green-100 text-green-800',
    'premium': 'bg-blue-100 text-blue-800',
    'scholarship': 'bg-purple-100 text-purple-800'
  }

  const canAccess = () => {
    if (course.tier === 'free') return true
    if (course.tier === 'premium' && (accessTier === 'plus' || accessTier === 'pro' || accessTier === 'business' || accessTier === 'premium_access')) return true
    if (course.tier === 'scholarship' && (accessTier === 'pro' || accessTier === 'business' || accessTier === 'premium_access')) return true
    return false
  }

  const isLocked = !canAccess()

  const handleCourseClick = () => {
    if (!course.isAvailable) {
      alert('Courses are coming soon! Learning Hub is under development.')
      return
    }
    
    if (!accessTier) {
      navigate('/auth')
      return
    }

    if (isLocked) {
      alert('This course requires a higher subscription tier. Upgrade to access premium content.')
      return
    }

    navigate(`/course/${course.id}`)
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -4 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col min-h-[480px] group relative"
    >
      {/* Coming Soon Overlay for all courses */}
      {!course.isAvailable && (
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm rounded-xl z-10 flex items-center justify-center">
          <div className="text-center p-6">
            <AlertCircle className="w-12 h-12 text-yellow-300 mx-auto mb-3" />
            <h3 className="text-xl font-bold text-white mb-2">Coming Soon</h3>
            <p className="text-white/80 text-sm">Learning Hub is in development</p>
          </div>
        </div>
      )}

      {/* Course Image */}
      <div className="relative h-48 bg-gray-200 flex-shrink-0">
        <img 
          src={course.image} 
          alt={course.title}
          className="w-full h-full object-cover"
        />
        
        {/* Badges Container */}
        <div className="absolute top-4 left-4 right-4 flex justify-between items-start">
          {/* Left side - Skill Level */}
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${skillColors[course.skillLevel]} flex-shrink-0`}>
            {course.skillLevel}
          </span>
          
          {/* Right side - Tier */}
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${tierColors[course.tier]} flex-shrink-0`}>
            {course.tier === 'free' ? 'Free' : course.tier === 'premium' ? 'Plus' : 'Pro'}
          </span>
        </div>

        {/* Coming Soon Badge */}
        {!course.isAvailable && (
          <div className="absolute bottom-4 left-4">
            <span className="px-3 py-1 bg-yellow-500 text-white text-xs font-medium rounded-full flex items-center gap-1">
              <AlertCircle className="w-3 h-3" />
              Coming Soon
            </span>
          </div>
        )}
      </div>

      {/* Content Area */}
      <div className="p-6 flex flex-col flex-1">
        {/* Topic badge - Centered */}
        <div className="mb-4 flex-shrink-0 flex justify-center">
          <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
            {course.category}
          </span>
        </div>

        {/* Title */}
        <div className="mb-3 flex-shrink-0">
          <h3 className="text-xl font-bold text-gray-900 leading-tight text-center">
            {course.title}
          </h3>
        </div>

        {/* Description */}
        <div className="flex-1 mb-6 min-h-0">
          <div className="text-gray-600 text-sm leading-relaxed text-center">
            {course.description}
          </div>
        </div>

        {/* Metadata */}
        <div className="flex items-center justify-between text-xs text-gray-500 mb-6 flex-shrink-0 space-x-2">
          {/* Duration */}
          <div className="flex items-center space-x-1.5 min-w-0 flex-1 justify-center">
            <Clock className="w-3.5 h-3.5 flex-shrink-0" />
            <span className="truncate">{course.duration}</span>
          </div>
          
          {/* Modules */}
          <div className="flex items-center space-x-1.5 min-w-0 flex-1 justify-center">
            <BookOpen className="w-3.5 h-3.5 flex-shrink-0" />
            <span className="truncate">{course.modules.length} modules</span>
          </div>
          
          {/* Students */}
          <div className="flex items-center space-x-1.5 min-w-0 flex-1 justify-center">
            <Users className="w-3.5 h-3.5 flex-shrink-0" />
            <span className="truncate">{course.students?.toLocaleString() || '0'}</span>
          </div>
        </div>

        {/* Rating */}
        <div className="flex items-center justify-center text-xs text-gray-500 mb-6 flex-shrink-0">
          <div className="flex items-center space-x-1.5">
            <Star className="w-3.5 h-3.5 fill-current text-yellow-400 flex-shrink-0" />
            <span>{course.rating} rating</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3 mt-auto pt-4 flex-shrink-0">
          <button
            onClick={handleCourseClick}
            disabled={!course.isAvailable}
            className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 text-white rounded-lg font-medium transition-colors duration-200 ${
              !course.isAvailable 
                ? 'bg-gray-400 cursor-not-allowed' 
                : isLocked 
                  ? 'bg-gray-500 hover:bg-gray-600' 
                  : 'bg-primary hover:bg-primary/90'
            }`}
          >
            {!course.isAvailable ? (
              <>
                <AlertCircle className="w-5 h-5" />
                <span>Coming Soon</span>
              </>
            ) : isLocked ? (
              <>
                <Lock className="w-5 h-5" />
                <span>Upgrade Required</span>
              </>
            ) : (
              <>
                <BookOpen className="w-5 h-5" />
                <span>{isEnrolled ? 'Continue Learning' : 'View Course'}</span>
              </>
            )}
          </button>
          
          {/* Certificate Button */}
          {course.hasCertificate && course.isAvailable && !isLocked && (
            <button
              onClick={() => navigate(`/course/${course.id}#certificate`)}
              className="flex items-center justify-center px-4 py-3 bg-yellow-500 text-white rounded-lg font-medium hover:bg-yellow-600 transition-colors duration-200 flex-shrink-0"
              title="View Certificate Info"
            >
              <Award className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </motion.div>
  )
}

export default CourseCard